import * as React from 'react';

const Ban = (): JSX.Element => {
  return (
    <svg
        style={{
            width:"32px",
            height: "32px"
        }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0003 2.66602C13.3632 2.66602 10.7854 3.448 8.59273 4.91309C6.40007 6.37817 4.69111 8.46055 3.68194 10.8969C2.67277 13.3333 2.40872 16.0141 2.92319 18.6006C3.43766 21.187 4.70754 23.5627 6.57224 25.4274C8.43694 27.2921 10.8127 28.562 13.3991 29.0765C15.9855 29.591 18.6664 29.3269 21.1028 28.3177C23.5391 27.3086 25.6215 25.5996 27.0866 23.407C28.5517 21.2143 29.3337 18.6364 29.3337 15.9993C29.3337 14.2484 28.9888 12.5146 28.3187 10.8969C27.6487 9.27923 26.6665 7.80937 25.4284 6.57126C24.1903 5.33314 22.7205 4.35102 21.1028 3.68096C19.4851 3.01089 17.7513 2.66602 16.0003 2.66602ZM16.0003 26.666C13.1714 26.666 10.4582 25.5422 8.45786 23.5418C6.45747 21.5414 5.33366 18.8283 5.33366 15.9993C5.33072 13.6305 6.12435 11.3294 7.587 9.46602L22.5337 24.4127C20.6703 25.8753 18.3692 26.669 16.0003 26.666ZM24.4137 22.5327L9.467 7.58602C11.3304 6.12337 13.6315 5.32974 16.0003 5.33268C18.8293 5.33268 21.5424 6.45649 23.5428 8.45688C25.5432 10.4573 26.667 13.1704 26.667 15.9993C26.6699 18.3682 25.8763 20.6693 24.4137 22.5327Z"
        fill="#EB5757"
      />
    </svg>
  );
};

export { Ban };



// WEBPACK FOOTER //
// ./src/components/svg/Ban.tsx